import React from 'react';
import Icon from '../../../components/AppIcon';

const VideoPreview = ({ file }) => {
  return (
    <div className="w-full h-full bg-muted rounded-lg flex flex-col items-center justify-center p-8">
      <div className="bg-card rounded-full p-6 mb-6 shadow-md">
        <Icon name="Video" size={64} className="text-primary" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">
        Video File
      </h3>
      <p className="text-sm text-muted-foreground text-center max-w-md mb-6">
        Video preview is not available in this view. Download the file to play it in your media player.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
        <div className="flex-1 bg-card border border-border rounded-lg p-4">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Film" size={16} className="text-muted-foreground" />
            <span className="text-xs text-muted-foreground">Format</span>
          </div>
          <p className="text-sm font-medium text-foreground">{file?.type}</p>
        </div>
        
        <div className="flex-1 bg-card border border-border rounded-lg p-4">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Clock" size={16} className="text-muted-foreground" />
            <span className="text-xs text-muted-foreground">Duration</span>
          </div>
          <p className="text-sm font-medium text-foreground font-mono">
            {file?.duration || 'Unknown'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VideoPreview;